import { createSelector } from '@reduxjs/toolkit';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';
import { CurrencySchema } from '../actions';

const currencyProjections = {} as ObjectOfAny;

currencyProjections.currencyOptionsList = createSelector(
    (state: RootState) => state.currency.currency,
    currencies => {
        if (currencies.allIds.length === 0) {
            return null;
        }
        return [
            ...currencies.allIds.map((code: string) => ({
                label: currencies.byId[code].name,
                key: currencies.byId[code].code,
            })),
        ];
    },
);

currencyProjections.currencies = createSelector(
    (state: RootState) => state.currency.currency,
    currencies => {
        if (currencies.allIds.length === 0) {
            return null;
        }
        return [
            ...currencies.allIds.map((code: string) => ({
                id: currencies.byId[code].id,
                code: code,
                name: currencies.byId[code].name,
                symbol: currencies.byId[code].symbol,
                isDefault: currencies.byId[code].isDefault,
                symbolSeparated: currencies.byId[code].symbolSeparated,
            })),
        ];
    },
);

currencyProjections.defaultCurrencies = createSelector(
    (state: RootState) => state.currency.currency,
    currencies => {
        if (currencies.allIds.length === 0) {
            return null;
        }
        return [
            ...currencies.allIds
                .map((code: string) => ({
                    id: currencies.byId[code].id,
                    code: code,
                    name: currencies.byId[code].name,
                    symbol: currencies.byId[code].symbol,
                    isDefault: currencies.byId[code].isDefault,
                    symbolSeparated: currencies.byId[code].symbolSeparated,
                }))
                .filter((c: CurrencySchema) => c.isDefault === true),
        ];
    },
);

currencyProjections.currencyOptionsListForm = createSelector(
    (state: RootState) => state.currency.currency,
    currencies => {
        if (currencies.allIds.length === 0) {
            return null;
        }
        return [
            ...currencies.allIds.map((code: string) => ({
                label: currencies.byId[code].name,
                value: currencies.byId[code].code,
            })),
        ];
    },
);

export default currencyProjections;
